class DataListFriendsController {

    constructor() {

        this._dataListTemplate = null;
        this._friendsListTemplate = null;
        this._dataListData = new DataListData();
        this._dataListUtils = new DataListUtils();
        this._slideActionsFriendList = new SlideActionsFriendList();

        this._loadTemplates();

    }

    _loadTemplates() {

        this._dataListTemplate = Handlebars.compile($("#dataListScreen").html());
        this._friendsListTemplate = Handlebars.compile($("#friendsListFragment").html());

    }

    _enableHandlers() {

        $("section.data-list-section div.back-button").on("click.closeScreen", this._dataListUtils.closeScreen.bind(this));
        $("section.data-list-section div.search-button").on("click.openSearchInput", this._dataListUtils.onToggleSeachButton.bind(this));
        $("section.data-list-section form.search-form").on("submit.search", this._onSearchSubmit.bind(this));
        $("section.data-list-section input.search-input").on("input.change", this._dataListUtils.onInputChange.bind(this));
        $("section.data-list-section div.clear-search-button").on("click.clearSearch", this._dataListUtils.onClearSearch.bind(this));

    }

    _drawScreen(context) {

        baseController.stackSimpleContent(this._dataListTemplate, context);

        const $sectionContent = $("section.data-list-section div.section-content");

        if (context.friends.length > 0) {

            $sectionContent.html(this._friendsListTemplate({
                world: world,
                friends: context.friends,
                type: 'friends',
                friendsCustomization: baseController.userCustomization(),
                enabledSlideButton: true
            }));

            $sectionContent.on("click.openFriendProfile", ".friend-item.is-directory", function(event) {
                event.preventDefault();
                event.stopPropagation();
                api.getUserProfile(world.token, $(this).data("user"), false);
            });

        } else {

            $sectionContent.addClass("empty-data-info");
            $sectionContent.html("<div class='text'>" + Translator.trans("TR_NO_HAY_NADIE_POR_AQUI").replace("\n", "<br>") + "</div>");

        }

    }

    _onSearchSubmit(event) {

        function _onGetUsersSuccess(response) {

            if (api.checkisValidResult(response)) {

                const $sectionSubtitle = $("div.section-header p.subtitle");
                const $sectionContent = $("section.data-list-section div.section-content");
                const totalUsers = response.result.total;

                $sectionSubtitle.text(sprintf(Translator.trans("TR_X_USUARIOS"), totalUsers));

                _.forEach(response.result.users, function(user) {
                    user.icon = user.user_icon;
                    user.level_icon = user.level.icon;
                    user.level_color = user.level.color;
                });

                if (searchTerm.length > 0) {
                    $clearSearchButton.show();
                } else {
                    $clearSearchButton.hide();
                }

                $sectionContent.html(that._friendsListTemplate({
                    world: world,
                    friends: response.result.users,
                    type: 'friends',
                    friendsCustomization: baseController.userCustomization(),
                    enabledSlideButton: true
                }));

                that._slideActionsFriendList.initialize();

            }

        }

        const $this = $(event.currentTarget);
        const $dataListSection = $("section.data-list-section");
        const $searchInput = $this.find(".search-input");
        const $clearSearchButton = $("div.clear-search-button");
        const searchTerm = $searchInput.val().trim();
        const documentId = $dataListSection.data("document");
        const commentId = $dataListSection.data("comment");
        const listType = $dataListSection.data("list");
        const socialTypes = new SocialActivitiesTypes().getTypes();
        const that = this;

        event.preventDefault();

        if (listType === socialTypes.LIKE_COMMENT_ACTIVITY_TYPE) {
            api.getDocumentCommentLikes(commentId, searchTerm, _onGetUsersSuccess, false);
        } else {
            api.getDocumentUsersSocialActivity(documentId, listType, searchTerm, _onGetUsersSuccess, false);
        }

    }

    initialize(data) {

        this._drawScreen(data);
        this._enableHandlers();
        this._dataListUtils.changeHeaderMode(this._dataListData);

    }

}